module.exports = __webpack_public_path__ + "img/logo.a1c54a03.svg";